export const VisaBadgeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="30" viewBox="0 0 46 30" fill="none">
    <rect width="46" height="30" rx="6" fill="#312E81" />
    <text
      x="23"
      y="19.5"
      textAnchor="middle"
      fill="#FFFFFF"
      fontFamily="Helvetica, Arial, sans-serif"
      fontSize="11"
      fontStyle="italic"
      fontWeight="800"
      letterSpacing="0.6">
      VISA
    </text>
  </svg>
);
